export function customTooltip(generateLabel, generateValue) {
  return {
    // Disable the on-canvas tooltip
    enabled: false,

    external: function ({ tooltip: tooltipModel }) {
      // Tooltip Element
      let tooltipEl =
        this._chart.canvas.parentNode.querySelector("#chartjs-tooltip");

      // Create element on first render
      if (tooltipEl) tooltipEl.parentNode.removeChild(tooltipEl);

      // Hide if no tooltip
      if (tooltipModel.opacity === 0) return;

      tooltipEl = document.createElement("div");
      tooltipEl.id = "chartjs-tooltip";
      tooltipEl.classList.add("chart-tooltip");
      tooltipEl.innerHTML = "<div></div>";
      this._chart.canvas.parentNode.appendChild(tooltipEl);

      // Set caret Position
      tooltipEl.classList.remove("above", "below", "no-transform");
      if (tooltipModel.yAlign) {
        tooltipEl.classList.add(tooltipModel.yAlign);
      } else {
        tooltipEl.classList.add("no-transform");
      }

      function getBody(bodyItem) {
        return bodyItem.lines;
      }

      // Set Text
      if (tooltipModel.body) {
        const titleLines = tooltipModel.title || [];
        const bodyLines = tooltipModel.body.map(getBody);

        let innerHtml = "";

        titleLines.forEach(function (_title) {
          innerHtml += `<span class="label">${generateLabel(
            tooltipModel.dataPoints[0].dataIndex
          )}</span>`;
        });

        bodyLines.forEach(function (_body, _i) {
          innerHtml += `<span class="value">${generateValue(
            tooltipModel.dataPoints[0].dataIndex
          )}</span>`;
        });
        innerHtml += "</tbody>";

        const root = tooltipEl.querySelector("div");
        root.innerHTML = innerHtml;
      }

      // Display, position, and set styles for font
      tooltipEl.style.opacity = 1;
      tooltipEl.style.position = "absolute";
      const left = tooltipModel.caretX;
      if (left + tooltipEl.offsetWidth > this._chart.canvas.offsetWidth) {
        tooltipEl.style.right = `${this._chart.canvas.offsetWidth - left}px`;
        tooltipEl.style.left = "auto";
      } else {
        tooltipEl.style.left = `${left - 10}px`;
        tooltipEl.style.right = "auto";
      }
      tooltipEl.style.top = tooltipModel.caretY + "px";
      tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
      tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
      tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
      tooltipEl.style.pointerEvents = "none";
    }
  };
}
